import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		mapData: null,
		centerMapData: null
	},
	getters: {},
	mutations: {
		setMapData(state, value) {
			state.mapData = value
		},
		setCenterMapData(state, value) {
			state.centerMapData = value
		}
	},
	actions: {},
	modules: {}
})